export const photography_visual = [
  { char: '📸', name: 'Camera with Flash', nameZh: '相機紀錄', keywords: ['photo', 'pic', 'shoot', '拍照'], hot: true },
  { char: '📷', name: 'Camera', nameZh: '經典相機', keywords: ['photo', 'classic', 'canon', 'sony'] },
  { char: '📹', name: 'Video Camera', nameZh: '錄影紀錄', keywords: ['video', 'film', 'vlog'] },
  { char: '🎞️', name: 'Film Frames', nameZh: '底片/電影', keywords: ['movie', 'story', 'retro'] },
  { char: '📽️', name: 'Movie Projector', nameZh: '投影/首映', keywords: ['show', 'film', 'watch'] },
  { char: '🎬', name: 'Clapper Board', nameZh: '開機拍板', keywords: ['action', 'video', 'youtube'], hot: true },
  { char: '🖼️', name: 'Frame', nameZh: '畫框/展覽', keywords: ['art', 'gallery', 'photo'] },
  { char: '🔦', name: 'Flashlight', nameZh: '補光', keywords: ['light', 'dark', 'search'] },
  { char: '💡', name: 'Light Bulb', nameZh: '靈感/光影', keywords: ['idea', 'light', 'vision'] },
  { char: '🔭', name: 'Telescope', nameZh: '長焦/遠望', keywords: ['zoom', 'far', 'discover'] },
];